import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import moment from 'moment';

@Component({
    selector: 'tt-job-schedule',
    templateUrl: './job-schedule.component.html',
    styleUrls: ['./job-schedule.component.css'],
    standalone: false
})
export class JobScheduleComponent implements OnInit {
    jobScheduleKeyno;

    public selectedBgJobScheduleMain: string = 'BASIS';

    public edit?: Edit;

    public selectListRepeatEveryTypes: RepeatEveryTypeItem[] = [];

    public selectListRepeatEveryNumbers: RepeatEveryNumberItem[] = [];

    public saving = false;

    public addingToQueue = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.jobScheduleKeyno = this.stateService.getStateParams()['jobschedule_keyno'];
    }

    private async loadEdit() {
        if (!!this.jobScheduleKeyno) {
            const response = (await this.datatask.Post(1663, { jobschedule_keyno: this.jobScheduleKeyno }))[0];

            this.edit = response;

            this.edit!.execute_at_time = moment.utc(this.edit!.execute_at_time).local().format('YYYY-MM-DD HH:mm:ss');
            this.edit!.execute_from_time = moment.utc(this.edit!.execute_from_time).local().format('YYYY-MM-DD HH:mm:ss');
            this.edit!.execute_to_time = moment.utc(this.edit!.execute_to_time).local().format('YYYY-MM-DD HH:mm:ss');
            this.edit!.last_add_to_jobqueue_dt = moment.utc(this.edit!.last_add_to_jobqueue_dt).local().format('YYYY-MM-DD HH:mm:ss');
            this.edit!.last_processing_end_dt = moment.utc(this.edit!.last_processing_end_dt).local().format('YYYY-MM-DD HH:mm:ss');
            this.edit!.last_processing_start_dt = moment.utc(this.edit!.last_processing_start_dt).local().format('YYYY-MM-DD HH:mm:ss');
            this.edit!.next_run_datetime = moment.utc(this.edit!.next_run_datetime).local().format('YYYY-MM-DD HH:mm:ss');
        }
    }

    private async loadRepeatEveryTypes() {
        this.selectListRepeatEveryTypes = await this.datatask.Post(1664);
    }

    private async loadRepeatEveryNumbers() {
        if (!this.edit) return;

        return this.selectListRepeatEveryNumbers = await this.datatask.Post(1665, { repeat_every_type: this.edit.repeat_every_type });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;
                let parms = this.edit;

                const dateToday = moment().format('YYYY-MM-DD');
                const executeAt = moment(dateToday + ' ' + parms.execute_at_time, 'YYYY-MM-DD HH:mm:ss');
                const executeFrom = moment(dateToday + ' ' + parms.execute_from_time, 'YYYY-MM-DD HH:mm:ss');
                const executeTo = moment(dateToday + ' ' + parms.execute_to_time, 'YYYY-MM-DD HH:mm:ss');

                if (executeTo.isSameOrBefore(executeFrom)) executeTo.add(1, 'day');

                parms.execute_at_time = executeAt.utc().format('YYYY-MM-DD HH:mm:ss');
                parms.execute_from_time = executeFrom.utc().format('YYYY-MM-DD HH:mm:ss');
                parms.execute_to_time = executeTo.utc().format('YYYY-MM-DD HH:mm:ss');

                const response = (await this.datatask.Post(1666, parms))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async addToQueueChanges() {
        if (!!this.edit) {
            try {
                this.addingToQueue = true;
                let parms = this.edit;

                const dateToday = moment().format('YYYY-MM-DD');
                const executeAt = moment(dateToday + ' ' + parms.execute_at_time, 'YYYY-MM-DD HH:mm:ss');
                const executeFrom = moment(dateToday + ' ' + parms.execute_from_time, 'YYYY-MM-DD HH:mm:ss');
                const executeTo = moment(dateToday + ' ' + parms.execute_to_time, 'YYYY-MM-DD HH:mm:ss');

                if (executeTo.isSameOrBefore(executeFrom)) executeTo.add(1, 'day');

                parms.execute_at_time = executeAt.utc().format('YYYY-MM-DD HH:mm:ss');
                parms.execute_from_time = executeFrom.utc().format('YYYY-MM-DD HH:mm:ss');
                parms.execute_to_time = executeTo.utc().format('YYYY-MM-DD HH:mm:ss');

                const responseSave = (await this.datatask.Post(1666, parms))[0];

                if (responseSave?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: responseSave.errormessage
                    });
                } else {
                    const responseAddToQueue = (await this.datatask.Post(3400, parms))[0];

                    if (responseAddToQueue?.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            translateTitle: true,
                            message: responseAddToQueue.errormessage
                        });
                    } else {
                        this.loadEdit();
                    }
                }
            } finally {
                this.addingToQueue = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'repeat_every_type':
                this.loadRepeatEveryNumbers();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadRepeatEveryTypes();
        this.loadRepeatEveryNumbers();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    jobschedule_keyno: string;
    jobschedule_name: string;
    reg_datetime: string;
    reg_by_portal_user_keyno: string;
    mod_datetime: string;
    mod_by_portal_user_keyno: string;
    isactive: string;
    do_repeat: string;
    repeat_every_type: string;
    repeat_every_number: string;
    repeat_monday: string;
    repeat_tuesday: string;
    repeat_wednesday: string;
    repeat_thursday: string;
    repeat_friday: string;
    repeat_saturday: string;
    repeat_sunday: string;
    execute_from_time: string;
    execute_to_time: string;
    execute_at_time: string;
    execute_at_dayinmonth: string;
    execute_at_month: string;
    p2_datatask_keyno: string;
    processing_parms: string;
    processing_count: string;
    last_add_to_jobqueue_dt: string;
    last_processing_start_dt: string;
    last_processing_end_dt: string;
    last_processing_code: string;
    last_processing_message: string;
    continue_if_error: string;
    next_run_datetime: string;
    run_parallell: string;
    delete_job_after_execute: string;
    proc_name: string;
}

interface RepeatEveryTypeItem {
    repeat_every_type_id: string;
    repeat_every_type_name: string;
    orderby: number;
}

interface RepeatEveryNumberItem {
    repeat_every_number_id: string;
    repeat_every_number_name: string;
    orderby: number;
}
